export default "__VITE_ASSET__Clhgxpiy__"